import { render, staticRenderFns } from "./ReOpenOrderLayer.vue?vue&type=template&id=87697518&"
import script from "./ReOpenOrderLayer.vue?vue&type=script&lang=js&"
export * from "./ReOpenOrderLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports